interface DomainTab {
  id: string;
  label: string;
}

interface DomainTabsProps {
  tabs: DomainTab[];
  active: string;
  onChange: (id: string) => void;
  ariaLabel: string;
}

/** Tabs secundarios de dominio (clínica / pacientes / finanzas). */
export function DomainTabs({ tabs, active, onChange, ariaLabel }: DomainTabsProps) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="flex flex-wrap gap-1 border-b border-slate-200 dark:border-gray-800"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={`rounded-t-lg px-3 py-2 text-sm font-semibold transition ${
              isActive
                ? 'border-b-2 border-teal-600 text-teal-800 dark:border-teal-400 dark:text-teal-300'
                : 'text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200'
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
